export default __webpack_public_path__ + "static/media/ticker.3626d9c1.png";